/** Сегодняшняя календарная дата в локальной таймзоне, ГГГГ-ММ-ДД. */
export function localTodayIso(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Берёт календарную дату YYYY-MM-DD, не сдвигая её по UTC. */
export function toOptionalIsoDate(value) {
  if (value == null) return null;
  const raw = String(value).trim();
  if (!raw) return null;
  const match = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : raw;
}
